import menu from './zh-CN/menu'
import pages from './zh-CN/pages'
import pwa from './zh-CN/pwa'

export default {
  ...pages,
  ...menu,
  ...pwa,
}
